import { useCallback } from "react";
import { useLocation } from 'react-router-dom';
import { appsflyer, appsflyerEventName } from "../utils/appsflyer";
import URL from "../constant/URL";

import { openWebBrowser } from "../utils/utilityEtc";
import useAmplitude from "./useAmplitude";
import useUserInfo from "./useUserInfo"

export default function useWorksheet() {
  const { info } = useUserInfo();
  const { setAmplitudeLog } = useAmplitude();
  const location = useLocation();

  const handleWorkSheet = useCallback((item) => {
    const locale = localStorage.getItem('locale');
    

    const eventData = {
      name: '',
      event: {
        "소스 화면": location.pathname,
        "커리큘럼그룹": item?.thmaNm,
        "커리큘럼명": item?.stepNm,
        "소주제이름": item?.stgNm,
        "소주제코드": item?.stgCd,
      }
    }

    const appsflyerEventData = {
      eventName: '',
      eventParams: {
        af_content_type: item?.thmaNm,
        af_content_id: item?.stgCd
      }
    };

    switch (location.pathname) {
      case URL.COURSE_LEARNING.LIST:
        eventData.name = '코스학습워크시트 클릭';
        appsflyerEventData.eventName = appsflyerEventName.worksheet_courseclick;
        break;
      case URL.TOPIC_LEARNING:
        eventData.name = '주제학습워크시트 클릭';
        appsflyerEventData.eventName = appsflyerEventName.worksheet_topicclick;
        break;
      case URL.LEARNING.RESULT:
        eventData.name = '학습결과워크시트 클릭';
        appsflyerEventData.eventName = appsflyerEventName.worksheet_resultclick;
        break;
    }

    setAmplitudeLog({eventName: eventData});
    appsflyer(appsflyerEventData);
    
    console.log({ item });

    openWebBrowser(
      `${ process.env.REACT_APP_FRONT_WEB_URL }/worksheet?`
      + `${encodeURIComponent(
          `name=${info.learnerName}&lrnMbrId=${info.learnerId}&langCd=${locale}`
          + `&stgCd=${item?.stgCd}&memberType=${info?.memberType}&memberemail=${info?.userEmail}&type=appBtn`
        )}`
    )
  }, [info]);

  return {
    handleWorkSheet
  }
}